export const calculateScreenElementsHeight = () => {
  const mpgiAppHeader = document.getElementById('mpgi-navbar');
  const appGlobalNotification = document.getElementById('app-global-notification');
  const appContainer = document.getElementById('content-wrapper');
  const caseHeader = document.getElementById('case-header-wrapper');
  const edozvolaContentForm = document.getElementById('edozvola-content-form');
  const footer = document.getElementById('footer');

  let appHeaderHeight = 0;
  let appGlobalNotificationHeight = 0;
  let footerHeight = 0;

  if (mpgiAppHeader) {
    appHeaderHeight = appHeaderHeight + mpgiAppHeader.offsetHeight;
  }

  if (appGlobalNotification) {
    appGlobalNotificationHeight = appGlobalNotification.offsetHeight;
  }

  if (footer) {
    footerHeight = footer.offsetHeight;
  }

  if (appContainer) {
    const headerAndFooterHeight = appHeaderHeight + footerHeight + appGlobalNotificationHeight;
    appContainer.style.height = `calc(100% - ${headerAndFooterHeight}px)`;
  }

  if (edozvolaContentForm && caseHeader) {
    edozvolaContentForm.style.height = `calc(${appContainer.offsetHeight - (footerHeight + caseHeader.offsetHeight)}px)`;
  }
};
